export { default } from "./AcademyToC";
